export type NotificationType = 'application' | 'cancellation' | 'event_created';

export interface NotificationData {
  id: number;
  type: NotificationType;
  event: {
    id: number;
    title: string;
  };
  student: {
    id: number;
    name: string;
  } | null;
  company: {
    id:                 number;
    name:               string;
    prefecture:         string | null;
    city:               string | null;
    businessType:       string | null;
    employeeCountRange: string | null;
    contactEmail:       string;
  } | null;
  is_read: boolean;
  is_handled: boolean;
  created_at: string;
}

export interface NotificationListResponse {
  notifications: NotificationData[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
  };
}

export const NOTIFICATION_TEMPLATES: Record<NotificationType, (name: string, eventTitle: string) => string> = {
  application:   (name, title) => `${name} さんが「${title}」に参加申込しました`,
  cancellation:  (name, title) => `${name} さんが「${title}」の参加をキャンセルしました`,
  event_created: (name, title) => `${name} が「${title}」を作成しました`,
};

/** 通知に表示する名前を返す（学生名 or 企業名） */
export const getNotificationDisplayName = (ntf: NotificationData): string => {
  if (ntf.type === 'event_created') return ntf.company?.name ?? '企業';
  return ntf.student?.name ?? '';
};
